module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/truckFeatured3.webp";